import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { map } from 'rxjs/operators';

import { ApiService } from '../../core/upgraded-providers';

import { FeaturesService } from '../../features.service';

import { default as RESOURCES } from '../resource';
const {
    token, cpuUnlock, pixel, accessKey,
    energy, power, ops,
    metal, biomass, silicon, mist,

    oxidant, reductant, zynthium_bar,
    lemergium_bar, utrium_bar, keanium_bar, purifier,

    battery, ghodium_melt, composite, crystal, liquid,

    wire, switch_, transistor, microchip, circuit, device,
    cell, phlegm, tissue, muscle, organoid, organism,
    alloy, tube, fixtures, frame, hydraulics, machine,
    condensate, concentrate, extract, spirit, emanation, essence,

    O, H, Z, K, U, L, X,
    OH, ZK, UL, G,
    KH, KH2O, XKH2O, KO, KHO2, XKHO2,
    UH, UH2O, XUH2O, UO, UHO2, XUHO2,
    LH, LH2O, XLH2O, LO, LHO2, XLHO2,
    ZH, ZH2O, XZH2O, ZO, ZHO2, XZHO2,
    GH, GH2O, XGH2O, GO, GHO2, XGHO2
} = RESOURCES;

@Component({
    selector: 'app-market-all-orders',
    templateUrl: './all-orders.component.pug',
    styleUrls: ['./all-orders.component.less']
})
export class AllOrdersComponent implements OnInit {

    public shard = '';

    public resource = {
        token, cpuUnlock, pixel, accessKey,
        resources: [
            energy, power, metal,
            biomass, silicon, mist, ops,
        ],
        minerals: [O, H, Z, L, U, K, X],

        neutral1: [
            oxidant, reductant, zynthium_bar,
            lemergium_bar, utrium_bar, keanium_bar, purifier
        ],
        neutral2: [
            battery, ghodium_melt, composite, crystal, liquid
        ],
        factory_production: [
            alloy, tube, fixtures, frame, hydraulics, machine,
            cell, phlegm, tissue, muscle, organoid, organism,
            wire, switch_, transistor, microchip, circuit, device,
            condensate, concentrate, extract, spirit, emanation, essence
        ],

        compounds: [OH, ZK, UL, G],
        lab_production: [
            KH, KH2O, XKH2O, KO, KHO2, XKHO2,
            UH, UH2O, XUH2O, UO, UHO2, XUHO2,
            LH, LH2O, XLH2O, LO, LHO2, XLHO2,
            ZH, ZH2O, XZH2O, ZO, ZHO2, XZHO2,
            GH, GH2O, XGH2O, GO, GHO2, XGHO2
        ]
    };

    inventory$ = this._featuresSrv.data$.pipe(map(({ inventory }) => !!inventory));

    constructor(
        private _route: ActivatedRoute,
        private _apiService: ApiService,
        private _featuresSrv: FeaturesService
    ) { }

    ngOnInit() {
        this.shard = this._route.snapshot.data['shard'];

        this.getData(this.shard);
    }

    async getData(shard: string): Promise<any> {
        const { list } = await this._apiService.get('game/market/orders-index', { shard });

        Object.keys(RESOURCES).forEach((_id) => {
            RESOURCES[_id].selling = null;
            RESOURCES[_id].buying = null;
            RESOURCES[_id].count = null;
        });

        for (const r of list) {
            if (RESOURCES[r._id]) {
                Object.assign(RESOURCES[r._id], { ...r });
            }
        }
    }

    onChangeShard(shard: string) {
        this.shard = shard;

        this.getData(this.shard);
    }
}
